import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { bbc } from '../../redux/bbc/selectors'
import { clientInfo } from '../../redux/clientInfo/selectors'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { entity } from '../../redux/entityInfo/selectors'
import { getNewFlagsCount } from '../../redux/flag/actions'
import { newFlagsCount } from '../../redux/flag/selectors'
import { listMyTasksPreview, updateTask } from '../../redux/myTasks/actions'
import { myTasksPreviewData } from '../../redux/myTasks/selectors'
import {
  clearNotesPanelForce,
  countNotes,
  requestNotesComposer,
  setNotesPanelState,
  toggleNotesOff,
} from '../../redux/notes/actions'
import {
  isNotesShown,
  notesCount,
  notesPanelForcedTab,
  notesPanelState,
} from '../../redux/notes/selectors'
import { ongoingReporting } from '../../redux/ongoingReporting/selectors'
import { userId as currentUserId } from '../../redux/profile/selectors'
import { reporting } from '../../redux/prospect/selectors'
import { trackVisualizations } from '../../redux/visualizationsTracking/actions'
import RightSidebar, { IProps } from './RightSidebar'

const selector = createStructuredSelector({
  isNotesShown,
  notesPanelState,
  notesPanelForcedTab,
  notesCount,
  reporting,
  bbc,
  entityInfo: entity,
  clientInfo,
  ongoingReporting,
  newFlagsCount,
  myTasksPreviewData,
  currentUserId,
})
const actions = {
  getNewFlagsCount,
  countNotes,
  toggleNotesOff,
  setNotesPanelState,
  clearNotesPanelForce,
  requestNotesComposer,
  trackVisualizations,
  listMyTasksPreview,
  updateTask,
}
const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, RightSidebar)
